/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  FindStoreFeatures200
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getFeatureFlipping = () => {
/**
 * Returns a map of feature flags and their enabled status for the specified store.
 * Feature flags control the availability of functionality such as action plans and
 * priority diagnoses. Features are configured via Paramethor and can be enabled
 * progressively per store for controlled rollouts.
 * @summary Get enabled features for a store
 */
const findStoreFeatures = (
    storeId: number,
 ) => {
      return customInstance<FindStoreFeatures200>(
      {url: `/api/v1/stores/${storeId}/features`, method: 'GET'
    },
      );
    }
  return {findStoreFeatures}};
export type FindStoreFeaturesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getFeatureFlipping>['findStoreFeatures']>>>
